import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { Banner } from '../../interfaces/Banner/Banner';
import { Pagination } from '../../interfaces/Pagination';
import { getBanners } from '../../api/Banner';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { BannersTable } from './BannersTable';

export const BannersPage = () => {
  const navigate = useNavigate();

  const [banners, setBanners] = useState<PaginatedResponse<Banner>>({
    data: [],
    totalCount: 0,
  });
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);

  const refreshBanners = () => {
    setLoading(true);
    getBanners(pagination)
      .then((b) => setBanners(b))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshBanners();
  }, [pagination]);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Bannerlar
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/visual/banners/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Banner
      </Button>
      <BannersTable
        banners={banners.data}
        totalCount={banners.totalCount}
        pagination={pagination}
        onPagination={setPagination}
      />
    </Box>
  );
};
